import type { FaireProductEntity } from "../../entity_types/product";

export const p_hpwwm7sshz: FaireProductEntity = {
  token: "p_hpwwm7sshz",
  type: "product",
  name: "5pair Adult Copper Quarter Crew Sport Socks Set",
  brandToken: "b_72ivqmkinu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/8cd07f284bfe110297b56f301575b0ef100429c76dc5e8b9b6dc693e393a35d0.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.32,
  description:
    "5-pair adult copper-infused quarter crew sport socks with cushioned footbed, arch support and odor control, designed for everyday training, work and casual wear.\n\nKey Features\n\n5-pair pack of adult quarter crew performance sport socks\n\nCopper-infused fibers help reduce odor and keep feet fresher longer\n\nCushioned footbed provides added comfort for workouts and long days\n\nBuilt-in arch support offers a more secure, contoured fit\n\nMoisture-management knit helps wick sweat to keep feet dry\n\nMedium-weight fabric ideal for sneakers, work shoes and casual boots\n\nUnisex sizing fits most adults; great staple for athletic and everyday use\n\nCase pack includes 12 sets, convenient for bulk buying and retail displays\n\nPrice on Faire is per Set; case pack includes 12 Sets.",
  tags: [],
  msrpDollars: 34.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:49.786Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
